import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MyOneTimeMessagesDismissedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyOneTimeMessagesDismissed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MyOneTimeMessagesDismissed","document":MyOneTimeMessagesDismissedDocument}} as const;
export type MyOneTimeMessagesDismissedQueryVariables = Types.Exact<{
  idMember: Types.Scalars['ID'];
}>;


export type MyOneTimeMessagesDismissedQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

/**
 * __useMyOneTimeMessagesDismissedQuery__
 *
 * To run a query within a React component, call `useMyOneTimeMessagesDismissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOneTimeMessagesDismissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOneTimeMessagesDismissedQuery({
 *   variables: {
 *      idMember: // value for 'idMember'
 *   },
 * });
 */
export function useMyOneTimeMessagesDismissedQuery(
  baseOptions: TrelloQueryHookOptions<
    MyOneTimeMessagesDismissedQuery,
    MyOneTimeMessagesDismissedQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: MyOneTimeMessagesDismissedDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    MyOneTimeMessagesDismissedQuery,
    MyOneTimeMessagesDismissedQueryVariables
  >(MyOneTimeMessagesDismissedDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useMyOneTimeMessagesDismissedLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    MyOneTimeMessagesDismissedQuery,
    MyOneTimeMessagesDismissedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyOneTimeMessagesDismissedQuery,
    MyOneTimeMessagesDismissedQueryVariables
  >(MyOneTimeMessagesDismissedDocument, options);
}
export type MyOneTimeMessagesDismissedQueryHookResult = ReturnType<
  typeof useMyOneTimeMessagesDismissedQuery
>;
export type MyOneTimeMessagesDismissedLazyQueryHookResult = ReturnType<
  typeof useMyOneTimeMessagesDismissedLazyQuery
>;
export type MyOneTimeMessagesDismissedQueryResult = Apollo.QueryResult<
  MyOneTimeMessagesDismissedQuery,
  MyOneTimeMessagesDismissedQueryVariables
>;
